'use strict';

// Do not use lodash's isNumber function as lodash might not be available in environments that use this module
function isNumber(value) {
  return typeof value === 'number' || (typeof value === 'object' && value instanceof Number);
}

/**
 * Applies trend to RoS
 * @param {*} measuredRos The product's measured RoS in the cluster
 * @param {*} rosOverride The product's RoS override, if it exists
 * @param {*} trendApplied - Optional, the trend set for this product
 * @returns
 */
function calculateFinalRoS({ measuredRos, rosOverride, trendApplied } = {}) {
  const hasOverride = isNumber(rosOverride);
  const ros = hasOverride ? rosOverride : measuredRos;

  if (!isNumber(ros)) return null;

  const hasTrend = isNumber(trendApplied);
  if (!hasTrend) return ros;

  // Do not calculate new ros if there is no old ros or trend is NaN or zero

  // Apply trend to rate of sale value as old value + old value * trend / 100%
  return ros + (ros * trendApplied) / 100;
}

/**
 * Computes volume rate of sale: final RoS divided by price.
 * @param {*} measuredRos The product's measured RoS in the cluster
 * @param {*} rosOverride The product's RoS override, if it exists
 * @param {*} trendApplied Optional trend applied to the product
 * @param {*} price The price to divide by
 * @returns {number|null} volumeRoS, or null if price is falsy or finalRoS is null
 */
function calculateVolumeRoS({ measuredRos, rosOverride, trendApplied, price } = {}) {
  if (!price) return null;
  const finalRoS = calculateFinalRoS({ measuredRos, rosOverride, trendApplied });
  if (finalRoS === null) return null;
  return finalRoS / price;
}

module.exports = { calculateFinalRoS, calculateVolumeRoS };
